import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '少女穿搭', path: '/category/fashion' },
  { label: '少女美妆', path: '/category/beauty' },
  { label: '少女生活', path: '/category/lifestyle' },
  { label: '少女社群', path: '/category/community' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="container-custom flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="text-xl md:text-2xl font-heading font-bold text-primary-500">
            少女领域
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'bg-primary-100 text-primary-700'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                    : 'text-white/90 hover:text-white hover:bg-white/20'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
            scrolled || !isHome
              ? 'text-foreground-800 hover:bg-background-100'
              : 'text-white hover:bg-white/20'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="打开菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-background-50 z-40 overflow-y-auto">
          <div className="container-custom py-6 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-5 py-3 rounded-lg text-base font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}